module.exports = __webpack_public_path__ + "static/media/filterSvg.d4585aff.svg";